import {ApolloLink} from '@apollo/client';
import createDirectivesCleanupLink from 'src/internal/revamp/links/createDirectivesCleanupLink';
import createObservabilityLink from 'src/internal/revamp/links/createObservabilityLink';
import createRouteToTestOrRealSchemaLink from 'src/internal/revamp/links/createRouteToTestOrRealSchemaLink';
import createSchemaLinksConfiguration from 'src/internal/revamp/links/createSchemaLinksConfiguration';
import createComponentKillswitchLink from 'src/public/links/createComponentKillswitchLink';
import createKillswitchLink from 'src/public/links/createKillswitchLink';

import type {SchemaConfig} from 'src/internal/revamp/config/types';
import type {ObservabilityFns} from 'src/internal/shared/observability/types';

export default function createApolloLink(
  schemas: ReadonlyArray<SchemaConfig>,
  observabilityFns?: ObservabilityFns,
): ApolloLink {
  const schemaLinksConfiguration = createSchemaLinksConfiguration(
    schemas,
    observabilityFns,
  );

  return ApolloLink.from([
    createObservabilityLink(),
    createDirectivesCleanupLink(),
    createKillswitchLink(),
    createComponentKillswitchLink(),
    createRouteToTestOrRealSchemaLink(schemaLinksConfiguration),
  ]);
}
